import React, { useState, useEffect, useCallback } from "react";
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from "moment";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import ToggleButton from '@material-ui/lab/ToggleButton';
import useStyles from "./styles";
import LeftArrow from "../../images/icons/leftArrow.png";
import RightArrow from "../../images/icons/rightArrow.png";
import DateIcon from "../../images/icons/date-icon.png";
import TodayIcon from "../../images/icons/today-icon.png";
import Loader from '../../components/Loader/Loader';
import DateCalendar from "./component/date-calendar";
import { Container, Button, FormControlLabel, FormGroup, Checkbox, Grid, Avatar } from '@material-ui/core';//Tooltip,
import Skeleton from '@material-ui/lab/Skeleton';
import "./component/calendar-style.css";
import TopSpacer from '../../components/Common/spacer/TopSpacer';
import { withSnackbar } from "../../components/Message/Alert";
import AddEvent from "./component/addEvent/addEvent";
import { PostDataAPI } from '../../Services/APIService';
import { GetUserInfo } from '../../Services/GetUserInfo';
import { formatDateTime2, getLocalDateFromUTC } from "../../components/Common/Extensions";
import { useHistory } from "react-router-dom";



const EventsCalendar = (props) => {
    const { showMessage } = props;
    var classes = useStyles();
    let history = useHistory();
    const localizer = momentLocalizer(moment);
    const DnDCalendar = withDragAndDrop(Calendar);
    const [loggedInUserID] = useState(JSON.parse(GetUserInfo()).user.userID);
    const [lstEvents, setLstEvents] = useState([
        {
            title: 'Event 1',
            start: new Date(2023, 8, 27, 10, 0), // September is month 8 (0-based)
            end: new Date(2023, 8, 27, 12, 0),
        },
        {
            title: 'Event 2',
            start: new Date(2023, 8, 28, 14, 0),
            end: new Date(2023, 8, 28, 16, 0),
        },
    ]);
    const [defaultDateView, setDefaultDateView] = useState(moment().toDate());
    const ColoredDateCellWrapper = ({ children }) =>
        React.cloneElement(React.Children.only(children), {
            style: {
                backgroundColor: '#F3F3F3',
            },
        });
    const customDayPropGetter = date => {

        let objDate;
        let resultDate = date;
        //var obj = objScheduleSlots.find((element, index) => {
        //    objDate = new Date(element.scheduleDateTime.split('T')[0]);

        //    if (objDate !== undefined && resultDate !== undefined && objDate.toDateString() === resultDate.toDateString())
        //        return objScheduleSlots[index]
        //});

        //if (obj !== undefined && resultDate !== undefined && objDate.toDateString() === resultDate.toDateString()) {
        //    return {
        //        className: 'available-slot',
        //    }
        //}
        //else
        //    return {
        //        className: 'not-available-slot',

        //    }
        return {
            className: 'available-slot',
        }
    }
    const customSlotPropGetter = date => {

        let objDate;
        let objEndDate;
        let resultDate = date;
        let resultEndDate = getSlotEndDate(date);
        //var obj = objScheduleSlots.find((element, index) => {
        //    objDate = new Date(element.scheduleDateTime);
        //    objEndDate = new Date(element.endDateTime);

        //    if (objDate !== undefined && resultDate !== undefined && (resultDate.getTime() >= objDate.getTime() && resultDate.getTime() < objEndDate.getTime()
        //        || resultEndDate.getTime() > objDate.getTime() && resultEndDate.getTime() <= objEndDate.getTime()))
        //        return objScheduleSlots[index];
        //});

        //if (obj !== undefined && resultDate !== undefined && (resultDate.getTime() >= objDate.getTime() && resultDate.getTime() <= objEndDate.getTime()
        //    || resultEndDate.getTime() >= objDate.getTime() && resultEndDate.getTime() <= objEndDate.getTime())) {

        //    return {
        //        className: 'available-slot',
        //    }
        //}
        //else
        //    return {
        //        className: 'not-available-slot',

        //    }
        return {
            className: 'available-slot',
        }
    }
    const getSlotEndDate = (dt) => {
        var duration = 30;//calendar slot duration.
        return new Date(dt.getTime() + duration * 60000);
    }
    const [viewChanging, setViewChanging] = useState('simple');
    const [dView, setDView] = useState('month');
    const [schedulerWidth, setSchedulerWidth] = useState(false);
    const [openDate, setOpenDate] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [scheduleDates, setScheduleDates] = useState({
        startDate: moment(moment().startOf('month').format('YYYY-MM-DD'), "YYYY-MM-DD").add(-7, 'days'),
        endDate: moment(moment().endOf('month').format('YYYY-MM-DD'), "YYYY-MM-DD").add(7, 'days')
    });
    const [objEventData, setObjEventData] = useState({});
    const dateOpenClose = () => {
        setOpenDate({ openDate: !openDate });
    }
    const addNew = () => {
        debugger;
        let d1 = new Date();
        //setnewEventDate(d1);
        var startDate = moment(new Date(d1.setHours(9)).setMinutes(0));
        var endDate = moment(new Date(d1.setHours(9)).setMinutes(30));
        var obj = {
            eventId: 0,
            startDate: startDate,
            endDate: endDate,
        };
        setObjEventData(obj);

        setShowAddEvent(true);
        //history.replace(location.pathname, null);
        //setDataId('');
        //setNewAppDate('');
        //setNewAppDateTime('');
        //setAppPatientName('');
        //setCurrentPage('app');
        //setTitle("New Appointment");
    };
    const [showAddEvent, setShowAddEvent] = useState(false);
    //const [newEventDate, setnewEventDate] = useState('');

    const setScheduleDate = (date, view) => {
        let startDate = moment(date).format('YYYY-MM-DD');
        let endDate = startDate;

        //getPatientAppointments(date.toISOString())


        if (view === "month") {
            startDate = moment(date).startOf('month').format('YYYY-MM-DD');
            endDate = moment(date).endOf('month').format('YYYY-MM-DD');
            //startDate = moment(startDate, "YYYY-MM-DD").add(-7, 'days')
            //endDate = moment(endDate, "YYYY-MM-DD").add(7, 'days')

        }
        if (view === "week") {
            startDate = moment(date).startOf('isoWeek').format('YYYY-MM-DD');
            endDate = moment(date).endOf('isoWeek').format('YYYY-MM-DD');

        }

        console.log(startDate, endDate)
        if (moment(startDate).isBefore(scheduleDates.startDate) || moment(endDate).isAfter(scheduleDates.endDate)) {

        }
        setScheduleDates({ startDate: startDate, endDate: endDate });
        getCalendarEvents(startDate, endDate);




        console.log(dView)
    }
    const dateClick = useCallback((date) => {

        setDefaultDateView(date);
        setScheduleDate(date, dView);

    }, [defaultDateView]);

    const onDateClick = useCallback((date, view) => {
        // console.log(date);
        setDefaultDateView(date);
        setScheduleDate(date, view);

        // let dateCheckIt = moment(date).format('MMM,yyyy')
        // console.log(date)
        // console.log(dateCheckIt)
    }, [defaultDateView]);
    const [tootipShowHide, setTootipShowHide] = useState(false);
    const [tootipData, setTootipData] = useState({});
    const [calendarShowHide, setCalendarShowHide] = useState(true);
    const onViewClick = useCallback((view) => {
        //console.log(view, defaultDateView)

        setScheduleDate(defaultDateView, view);



        setDView(view)

    }, [defaultDateView]);
    const onEventDrop = (data) => {
        setTootipShowHide(false);
        //if (!data.event.isBreak) {
        //    let obj = {
        //        patientAppointmentId: data.event.id,
        //        AppointmentDatetime: new Date(data.start),
        //        userLocationID: data.event.userLocationID,
        //        duration: data.event.duration,
        //        AppointmentTime: data.event.start.toLocaleTimeString()
        //    }

        //    PostDataAPI("appointment/updatePatientAppointmentbyScheduler", obj, true).then((result) => {

        //        if (result.success && result.data != null) {

        //            setDragDrop(obj);
        //        }
        //        else {
        //            showMessage("Provider slot", result.message, "info", 3000);
        //        }

        //    })
        //}

    };
    const eventStyleGetter = (event, start, end, isSelected) => {

        var bordercolor = null;
        var textColor = event.bgColor == "yellow" || event.bgColor == "orange" ? "#373a3c" : "white";
        if (event.bgColor == "none" || event.bgColor == "White") {
            textColor = "#11284B";
            bordercolor = "#d3d3d3";
        }
        var bgColor = event.bgColor;
        // console.log(event);
        var style = {}
        if (event.bgColor === "none" || event.bgColor === "White") {
            style = {
                color: "black",
                fontFamily: "Lato",
                fontSize: "10px",
                backgroundColor: bgColor,
                color: textColor,
                borderRadius: '0px',
                border: '0.1px solid' + bordercolor,
                display: 'block'
            };
        }
        else {
            style = {
                color: "black",
                fontFamily: "Lato",
                fontSize: "10px",
                backgroundColor: bgColor,
                color: textColor,
                borderRadius: '0px',
                border: '0px',
                display: 'block'
            };

        }
        return {
            style: style
        };
    }
    const isDateInCurrentMonth = (date) => {
        console.log(defaultDateView)
        const currentDate = new Date(); // Get current date
        return (
            date.getFullYear() === defaultDateView.getFullYear() &&
            date.getMonth() === defaultDateView.getMonth()
        );
    };
    const handleSelect = ({ start, end, allDay }) => {
        if (isDateInCurrentMonth(start)) {
            let d1 = new Date(start);
            //setnewEventDate(d1);
            var startDate = moment(new Date(d1.setHours(9)).setMinutes(0));
            var endDate = moment(new Date(d1.setHours(9)).setMinutes(30));
            var obj = {
                eventId: 0,
                startDate: startDate,
                endDate: endDate,
            };
            setObjEventData(obj);
            //let slotEndDate = getSlotEndDate(d1);
            setShowAddEvent(true);
        }
       
        return;
    }
    const CustomToolbar = (toolbar) => {

        const [activeView, setActiveView] = useState(0);

        const ViewChange = (action, examroom) => {
            console.log('selected view:' + activeView);
            if (action === "month") {
                setActiveView(0)
            }

            if (action === "week") {
                setActiveView(1)
            }

            if (action === "today") {
                setActiveView(2)
            }

            if (action === "day") {
                setActiveView(2)
            }



        }

        const setTodayView = (action) => {
            if (action === "day") {
                setActiveView(5)
            }
        }

        const ViewExamTab = (action) => {
            if (action === "day") {
                setActiveView(3)
            }
        }

        const navigate = action => {
            toolbar.onNavigate(action)
        }

        const TodayView = (action) => {
            //setIsLoading(true)

            setViewChanging('simple')
            setDView(action)

            setDefaultDateView(moment().toDate())

            toolbar.onView(action)


            setTodayView(action)

            //if (action === "day") {
            //    setTimeout(() => {
            //        setIsLoading(false)
            //    }, 1000)

            //}

        }

        const view = action => {
            //setIsLoading(true)
            setViewChanging('simple')
            toolbar.onView(action)
            setDView(action)

            ViewChange(action)

            //if (action === "day") {
            //    setTimeout(() => {
            //        setIsLoading(false)
            //    }, 1000)

            //}


        }

        return (
            <div className='rbc-toolbar'>
                <div className="rbc-btn-group">
                    <button type="button" onClick={addNew} title="+ Add New">+ Create an Event</button>
                </div>
                <span className="rbc-toolbar-label">
                    <button type="button" onClick={() => navigate('PREV')} title="PREVIOUS">
                        <img className="arrowIcon" src={LeftArrow} alt="PREV" /></button>
                    <span className="schedulerdate" onClick={dateOpenClose} style={{ cursor: "pointer" }}><img className="schedulerdateIcon" src={DateIcon} alt="Date" /> {toolbar.label}</span>
                    <button type="button" onClick={() => navigate('NEXT')} title="NEXT"><img className="arrowIcon" src={RightArrow} alt="NEXT" /></button>
                </span>
                <div className="rbc-btn-group" style={{minWidth: '158px'}}>
                    {/*<button type="button" className={activeView === 5 ? classes.activeView : '' + 'customTodayBtn'} style={{ height: "33px !important" }} onClick={() => TodayView('day')}><img src={TodayIcon} alter="today" />Today</button>*/}
                    {/*<button type="button" className={activeView === 2 ? classes.activeView : ''} onClick={() => view('day')}>Daily</button>*/}
                    {/*<button type="button" className={activeView === 1 ? classes.activeView : ''} onClick={() => view('week')}>Weekly</button>*/}
                    {/*<button type="button" className={activeView === 0 ? classes.activeView : ''} onClick={() => view('month')}>Monthly</button>*/}

                </div>

            </div>
        )
    }
    const handleSuccessClose = (message) => {
        //var existingArray = [...lstEvents];
        //existingArray.push({
        //    title: data.eventName,
        //    start: new Date(data.newEventDate.getFullYear(), data.newEventDate.getMonth() , data.newEventDate.getDate(), 12, 0),
        //    end: new Date(2023, 9, 7, 16, 0)//new Date(data.newEventDate.getFullYear(), data.newEventDate.getMonth(), data.newEventDate.getDate(), 2, 0)
        //});
        showMessage("Success", message, "success", 3000);
        //setLstEvents(existingArray);
        getCalendarEvents();
        setShowAddEvent(false);
    }
    const getStartOfMonthUTC = (currentDate) => {
        const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1, 0, 0, 0, 0);
        return startOfMonth.toISOString();
    };
    const getEndOfMonthUTC = (currentDate) => {
        const endOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0, 0, 23, 59, 59);
        return endOfMonth.toISOString();
    };
    function getCalendarEvents(from_date, to_date) {
        var todayDate = new Date();
        //if (!from_date)
        //    from_date = todayDate.getFullYear() + '-' + (todayDate.getMonth() + 1) + '-' + 1;
        //if (!to_date) {
        //    to_date = new Date(todayDate.getFullYear(), todayDate.getMonth() + 2, 0);
        //    to_date = to_date.getFullYear() + '-' + to_date.getMonth() + '-' + to_date.getDate();
        //}

        debugger;
        var todayDate = new Date();
        if (!from_date) {
            from_date = getStartOfMonthUTC(todayDate);//todayDate.getFullYear() + '-' + (todayDate.getMonth() + 1) + '-' + 1;
        } else {
            from_date = getStartOfMonthUTC(new Date(from_date));//todayDate.getFullYear() + '-' + (todayDate.getMonth() + 1) + '-' + 1;
        }

        if (!to_date) {
            to_date = getEndOfMonthUTC(todayDate);//to_date.getFullYear() + '-' + to_date.getMonth() + '-' + to_date.getDate();
        } else {
            to_date = getEndOfMonthUTC(new Date(to_date));//to_date.getFullYear() + '-' + to_date.getMonth() + '-' + to_date.getDate();
        }

        var obj = [from_date, to_date];
        PostDataAPI("fdnevents/getAllEvents", obj).then((result) => {
            if (result.success && result.data != null) {
                console.log(result.data);
                setLstEvents(
                    result.data.map((item, i) => {
                        return {
                            // allDay: true,    
                            id: item.eventId,
                            title: item.eventName,
                            start: getLocalDateFromUTC(item.startDate),
                            end: getLocalDateFromUTC(item.endDate),
                            bgColor: item.createdBy == loggedInUserID ? "Orange" : "Blue",
                            notes: item.eventDescription && item.eventDescription.length > 200 ? item.eventDescription.substring(0, 200) + '...' : item.eventDescription,
                            createDate: formatDateTime2(getLocalDateFromUTC(item.createDate)),
                            userName: item.userName,
                            photoPath: item.photoPath,
                            startDate: formatDateTime2(getLocalDateFromUTC(item.startDate)),
                            endDate: formatDateTime2(getLocalDateFromUTC(item.endDate)),
                            location: item.location,
                            distributionListId: item.distributionListId,
                            userEmail: item.userEmail,
                            attachmentFiles: item.attachmentFiles
                        };

                    }

                    ));


            }
            setIsLoading(false)
        })
    }
    const [currentBoxLeft, setCurrentBoxLeft] = useState(168);
    const [currentBoxTop, setCurrentBoxTop] = useState(139);
    const EventTest = ({ event }) => {
        //console.log(event)
        // let tooltipData = event.desc;
        //   <Tooltip classes={{ tooltip: classes.customTooltip }} title={tooltipData} >
        //   <span>{event.title} </span>
        //  </Tooltip>
        // let pAge=tootipData.age.slice(0, 8);
        // let eventAge=pAge.replace(',',''); 
        // console.log(ref.current.innerText)
        // return ReactDOM.findDOMNode(ref.current);
        const ref = React.useRef(null);
        const leaveMouse = (e) => {
            setTootipShowHide(false)
        }
        const onMouse = (e) => {
            const hoveredElement = e.target; // Get the element that triggered the event
            const element = hoveredElement.getBoundingClientRect();
            setCurrentBoxLeft(element.left - 250);
            setCurrentBoxTop(element.top);
            setTootipShowHide(true);
            setTootipData(
                event
            )
        };
        //let breakTitle = event.breakReason ? event.breakReason + ' ' + event.appointmentTime : "Break Time" + event.appointmentTime;
        let tootipTitle = "View Details";
        let pTitle = event.title.replace(/,/g, ', ');
        return (
            <span className="tooltipBox" title={tootipTitle} ref={ref} >

                {/*<img className="status-icon2" src={AIconBlue} alt="" />*/}

                <span onMouseOver={onMouse} onMouseLeave={leaveMouse} className="tootltipTitle">{pTitle}</span>

                {/*<img className="appointment-type-icon" src={WalkIcon} alt="Walk In" />*/}

            </span>
        )
    }
    const [selectedEventId, setSelectedEventId] = useState('');
    const [title, setTitle] = useState('Add Event');
    const eventView = (event) => {
        //history.replace(location.pathname, null);
        if (!event.isBreak) {
            var obj = {
                eventId: event.id,
                startDate: moment(new Date(event.start)),
                endDate: moment(new Date(event.end)),
                eventName: event.title,
                location: event.location,
                distributionListId: event.distributionListId,
                eventDescription: event.notes,
                attachmentFiles: event.attachmentFiles
            };
            setObjEventData(obj);
            //setSelectedEventId(event.eventId);
            //setnewEventDate(event.start);
            setShowAddEvent(true);
            //setAppPatientName(event.eventName);
            //setCurrentPage('app');
            setTitle("Edit Event");
            setTootipShowHide(false);
        }
    }
    useEffect(() => {
        getCalendarEvents();
    }, []);
    return (
        <>



            {isLoading ? <Loader></Loader> : ''}
            <TopSpacer></TopSpacer>



            <Container maxWidth={false} style={{ paddingTop: '10px' }} >


                <Grid container>

                    {
                        calendarShowHide ?
                            <div className="fulWidth">
                                {tootipShowHide ? !tootipData.isBreak ? <>
                                    <span className="tooltipBox">
                                        <ul className="desc" style={{ left: currentBoxLeft, top: currentBoxTop }}>
                                            <li className="headerTop" >
                                                <span className={'closeTooltip'} onClick={() => setTootipShowHide(false)}> X</span>
                                                <span className="headerTopLeftSide">
                                                    <Avatar src={tootipData.photoPath ? "." + tootipData.photoPath : "/static/media/profile-pic.7e2ec63d.jpg"} alt={tootipData.userName} />
                                                </span>
                                                <span className="headerTopRightSide">
                                                    <span className="headerTopTitle">{tootipData.userName}</span>
                                                    <span className="headerTopTitle">{tootipData.userEmail}</span>
                                                    {/*<span className="headerTopTitle02">Last Visit:  {tootipData.lastVisit}</span>*/}
                                                </span>
                                            </li>
                                            <li className="line"></li>
                                            <li>
                                                <span className="liTitle">Event:</span>
                                                <span className="liValue">{tootipData.title}</span>
                                            </li>
                                            <li>
                                                <span className="liTitle">Event Date:</span>
                                                <span className="liValue">{tootipData.startDate}</span>
                                            </li>
                                            <li>
                                                <span className="liTitle">Location:</span>
                                                <span className="liValue">{tootipData.location}</span>
                                            </li>


                                            <li className="notesli">
                                                <span className="liTitle">Description:</span>
                                                <span className="liValue notesValue">{tootipData.notes}</span>
                                            </li>
                                            <li className="line"></li>
                                            <li>
                                                <span className="liTitle">Created Date:</span>
                                                <span className="liValue">{tootipData.createDate}</span>
                                            </li>
                                        </ul>
                                    </span>
                                </> : "" : ""}
                                <DnDCalendar
                                    resizable
                                    selectable
                                    popup
                                    defaultDate={defaultDateView}
                                    date={defaultDateView}
                                    onNavigate={(date, view) => {
                                        onDateClick(date, view);
                                        // console.log('#### date=', date, action);
                                    }}
                                    onView={(view) => {
                                        onViewClick(view)
                                        //console.log('#### view', view);
                                    }}
                                    defaultView={dView}
                                    events={lstEvents}
                                    localizer={localizer}
                                    onEventDrop={onEventDrop}
                                    //onEventResize={onEventResize}
                                    eventPropGetter={(eventStyleGetter)}
                                    //onDragStart={console.log}
                                    style={{ minHeight: "750px", maxHeight: "800px", overflow: "auto" }}
                                    onSelectEvent={eventView}
                                    onSelectSlot={handleSelect}
                                    step={15}
                                    //timeslots= {1}
                                    components={{
                                        timeSlotWrapper: ColoredDateCellWrapper,
                                        toolbar: CustomToolbar,
                                        event: EventTest,
                                        // day: { header: MyCustomHeader },
                                        // week: { header: MyCustomHeader },
                                        // month: { header: MyCustomHeader },
                                        // agenda: {
                                        //     event: EventAgenda
                                        //   }

                                    }}
                                    isAllDay={false}
                                    allDayAccessor='allDay'
                                    titleAccessor='title'
                                    tooltipAccessor={null}//'desc'
                                    messages={{
                                        showMore: total => `+${total} more events`,
                                    }}
                                    dayLayoutAlgorithm='no-overlap'
                                    dayPropGetter={customDayPropGetter}
                                    slotPropGetter={customSlotPropGetter}
                                // resources=""
                                // resourceIdAccessor=""
                                // resourceTitleAccessor=""
                                //scrollToTime= {moment().set({ h: 10, m: 0 }).toDate()}

                                // slotPropGetter={customSlotPropGetter}
                                // step= {30}
                                // length={8}
                                // timeslots= {2}
                                // min= {'2021'}
                                // max= {schedulerEvent.endOf(new Date(), 'day')}
                                // scrollToTime= {schedulerEvent.startOf(new Date(), 'day')}
                                //timeslots={35}
                                // onDoubleClickEvent={eventClicked}
                                // rtl={true}
                                // showMultiDayTimes={true}
                                // views={['day', 'week', 'month', 'agenda', 'work_week']}
                                // views={{ day: true,week: true, month: true,}}

                                />
                            </ div>
                            : <>
                                <Skeleton className={classes.bgColor} animation="wave" variant="rect" height={30} width="100%" style={{ marginBottom: 10 }} />
                                <Skeleton className={classes.bgColor} height={660} animation="wave" variant="rect" width="100%"></Skeleton>
                            </ >
                    }

                </Grid>
            </Container>
            {showAddEvent ?
                <AddEvent
                    dialogOpenClose={() => { setShowAddEvent(true) }}
                    handleClose={() => { setShowAddEvent(false) }}
                    handleSuccessClose={(data) => { handleSuccessClose(data) }}
                    objEventData={objEventData}
                ></AddEvent> : ''}
        </>
    );
};
export default withSnackbar(EventsCalendar);
